"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreCardPlanType = exports.CoreCardTransactionCode = exports.CoreCardAccountStatusDescription = exports.CoreCardAccountStatus = exports.CardImageId = void 0;
/**
 * Defines the CardImageIDs we send to CoreCard such that the cardholder gets different types of
 * cards.
 * @TranslateToPython @TranslateToEnum
 */
var CardImageId;
(function (CardImageId) {
    /** Don't send CardImageID attribute to get the default card */
    CardImageId["CORE_CARD_DEFAULT_CARD_IMAGE_ID"] = "";
    /** The plastic card */
    CardImageId["CORE_CARD_BASIC_PLASTIC_CARD_IMAGE_ID"] = "41127502";
    /** The metal card */
    CardImageId["CORE_CARD_METAL_CARD_CARD_IMAGE_ID"] = "41127503";
})(CardImageId || (exports.CardImageId = CardImageId = {}));
/* @TranslateToPython */
var CoreCardAccountStatus;
(function (CoreCardAccountStatus) {
    CoreCardAccountStatus["Active"] = "2";
    CoreCardAccountStatus["Delinquent"] = "3";
    CoreCardAccountStatus["Overlimit"] = "4";
    CoreCardAccountStatus["Fraud"] = "7";
    CoreCardAccountStatus["Blocked"] = "10";
    CoreCardAccountStatus["Closed"] = "11";
    // By setting customer to be "VIP", the card velocity ADC rules will be ignored. This is used when we only want to refer to the "Spend Rule"
    CoreCardAccountStatus["Vip"] = "12";
    CoreCardAccountStatus["ChargedOff"] = "14";
    CoreCardAccountStatus["ClosedByCustomer"] = "16";
    CoreCardAccountStatus["OfacSuspended"] = "1010";
    CoreCardAccountStatus["Bankruptcy"] = "5202";
    CoreCardAccountStatus["NinetyDaysPastDue"] = "24705";
    CoreCardAccountStatus["Sold"] = "28423";
})(CoreCardAccountStatus || (exports.CoreCardAccountStatus = CoreCardAccountStatus = {}));
/* @TranslateToPython */
var CoreCardAccountStatusDescription;
(function (CoreCardAccountStatusDescription) {
    CoreCardAccountStatusDescription["Active"] = "Active";
    CoreCardAccountStatusDescription["Delinquent"] = "Delinquent";
    CoreCardAccountStatusDescription["Overlimit"] = "Overlimit";
    CoreCardAccountStatusDescription["Fraud"] = "Fraud";
    CoreCardAccountStatusDescription["Blocked"] = "Blocked";
    CoreCardAccountStatusDescription["Closed"] = "Closed";
    CoreCardAccountStatusDescription["ChargedOff"] = "Charged-off";
    CoreCardAccountStatusDescription["ClosedByCustomer"] = "Closed By Customer";
    CoreCardAccountStatusDescription["OfacSuspended"] = "OFAC Suspended";
    CoreCardAccountStatusDescription["NinetyDaysPastDue"] = "90DPD";
    CoreCardAccountStatusDescription["Vip"] = "VIP";
    CoreCardAccountStatusDescription["Bankruptcy"] = "B-Bankruptcy";
    CoreCardAccountStatusDescription["Sold"] = "Sold";
})(CoreCardAccountStatusDescription || (exports.CoreCardAccountStatusDescription = CoreCardAccountStatusDescription = {}));
// Final list of trancodes as of 07/23/2020: https://drive.google.com/file/d/1n79C-26Q-ZVDQr9Sq7qLHXfFniEjKBw3/view?usp=sharing
/* @TranslateToPython @TranslateToEnum */
var CoreCardTransactionCode;
(function (CoreCardTransactionCode) {
    CoreCardTransactionCode["DOMESTIC_SALE"] = "834240";
    CoreCardTransactionCode["DOMESTIC_SALE_REVERSAL"] = "834243";
    CoreCardTransactionCode["INTERNATIONAL_SALE"] = "834241";
    CoreCardTransactionCode["INTERNATIONAL_SALE_REVERSAL"] = "834244";
    CoreCardTransactionCode["BALANCE_TRANSFER"] = "834036";
    CoreCardTransactionCode["BALANCE_TRANSFER_REVERSAL"] = "834089";
    CoreCardTransactionCode["BALANCE_TRANSFER_NO_FEE"] = "8300143";
    CoreCardTransactionCode["BALANCE_TRANSFER_NO_FEE_REVERSAL"] = "8300430";
    CoreCardTransactionCode["BALANCE_TRANSFER_NO_FEE_PRINCIPAL"] = "834236";
    CoreCardTransactionCode["PURCHASE_REVERSAL_DOMESTIC"] = "834243";
    CoreCardTransactionCode["PURCHASE_REVERSAL_INTERNATIONAL"] = "834244";
    CoreCardTransactionCode["PURCHASE_REVERSAL_BALANCE_TRANSFER"] = "834089";
    CoreCardTransactionCode["CASH_ADVANCE_DEBIT"] = "83430";
    CoreCardTransactionCode["MANUAL_CASH_ADVANCE_REVERSAL"] = "8341135";
    CoreCardTransactionCode["INTEREST_CHARGES"] = "834614";
    CoreCardTransactionCode["INTEREST_CHARGES_DURING_PAYOFF"] = "834112";
    CoreCardTransactionCode["INTEREST_REASSESSMENT_AUTO_ACROSS_CYCLE"] = "834612";
    CoreCardTransactionCode["INTEREST_CHARGE_ADJUSTMENT_CREDIT"] = "834613";
    CoreCardTransactionCode["INTEREST_CHARGE_ADJUSTMENT"] = "834313";
    CoreCardTransactionCode["INTEREST_CHARGE_CREDIT_ADJUSTMENT_MANUAL"] = "834801";
    // Dedicated code for automated interest reversals on merchant refunds (30-day interest waiver). Distinct from the
    // MANUAL adjustment above so these system-originated credits are separable in reporting.
    CoreCardTransactionCode["MERCHANT_REFUND_INTEREST_REVERSAL"] = "83419003";
    CoreCardTransactionCode["INTEREST_CHARGE_MANUAL_ADJUSTMENT"] = "834618";
    CoreCardTransactionCode["INTEREST_REGULATION_ADJUSTMENT"] = "8341003";
    CoreCardTransactionCode["INTEREST_REVERSAL_ACROSS_CYCLES"] = "834113";
    // created interest and fee transfers here https://coretrack.corecard.com/edit_bug.aspx?id=178481
    CoreCardTransactionCode["INTEREST_TRANSFER"] = "8310202";
    CoreCardTransactionCode["FEE_TRANSFER"] = "8310206";
    CoreCardTransactionCode["RETURNED_PAYMENT_FEE"] = "834344";
    CoreCardTransactionCode["RETURNED_PAYMENT_FEE_ADJUSTMENT"] = "834345";
    CoreCardTransactionCode["CASH_ADVANCE_FEE_DEBIT"] = "834512";
    CoreCardTransactionCode["INTERNATIONAL_TRANSACTION_FEE"] = "834510";
    CoreCardTransactionCode["BALANCE_TRANSFER_FEE"] = "83906";
    CoreCardTransactionCode["CASH_ADVANCE_FEE_CREDIT"] = "834513";
    CoreCardTransactionCode["INTERNATIONAL_TRANSACTION_FEE_ADJUSTMENT"] = "834511";
    CoreCardTransactionCode["BALANCE_TRANSFER_FEE_ADJUSTMENT"] = "834106";
    CoreCardTransactionCode["LATE_PAYMENT_FEE"] = "834806";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_ADJUSTMENT"] = "834321";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_MANUAL_DEBIT_ADJUSTMENT"] = "83808";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_REASSESSMENT_AUTO_ACROSS_CYCLE"] = "83908";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_REASSESSMENT_AUTO_IN_CYCLE"] = "834064";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_REVERSAL_ACROSS_CYCLES"] = "83909";
    CoreCardTransactionCode["LATE_PAYMENT_FEE_REVERSAL_IN_CYCLE"] = "834805";
    CoreCardTransactionCode["MONTHLY_FEE"] = "834624";
    CoreCardTransactionCode["MONTHLY_FEE_ADJUSTMENT"] = "834107";
    CoreCardTransactionCode["CASHBACK_REDEMPTION_PAYMENT"] = "834140";
    CoreCardTransactionCode["CASHBACK_STATEMENT_CREDIT_REDEMPTION"] = "834100249";
    CoreCardTransactionCode["CASHBACK_STATEMENT_CREDIT_REDEMPTION_REVERSAL"] = "834100248";
    CoreCardTransactionCode["CASHBACK_POINT_DEBIT"] = "843802";
    CoreCardTransactionCode["MERCHANDISE_RETURN"] = "834041";
    CoreCardTransactionCode["MERCHANDISE_RETURN_REVERSAL"] = "83442";
    CoreCardTransactionCode["PURCHASE_RETURN_REVERSAL"] = "83442";
    CoreCardTransactionCode["PURCHASE_DEBIT_REVERSAL"] = "83443";
    CoreCardTransactionCode["PRINCIPAL_DEBIT_ADJUSTMENT"] = "834642";
    CoreCardTransactionCode["PRINCIPAL_CREDIT_ADJUSTMENT"] = "834052";
    CoreCardTransactionCode["PRINCIPAL_CREDIT_ADJUSTMENT_ALTERNATE"] = "834225";
    // credit for marketing reasons, ie PIF. IMPORTANT: Credits w/ this tran code are
    // 1) taxable to the cardholder, 2) paid by Aven (not our funding partners)
    CoreCardTransactionCode["PRINCIPAL_CREDIT_MARKETING"] = "8360049";
    CoreCardTransactionCode["PRINCIPAL_DEBIT_MARKETING"] = "8360048";
    CoreCardTransactionCode["PRINCIPAL_CREDIT_OPERATIONS"] = "8370049";
    CoreCardTransactionCode["PRINCIPAL_DEBIT_OPERATIONS"] = "8370048";
    CoreCardTransactionCode["PRINCIPAL_CREDIT_REMEDIATION"] = "83450049";
    CoreCardTransactionCode["PRINCIPAL_DEBIT_REMEDIATION"] = "83450048";
    CoreCardTransactionCode["PRINCIPAL_CREDIT_TRANSFER"] = "8350049";
    CoreCardTransactionCode["PRINCIPAL_DEBIT_TRANSFER"] = "8350048";
    CoreCardTransactionCode["CREDIT_BALANCE_REFUND"] = "834250";
    CoreCardTransactionCode["CREDIT_BALANCE_REFUND_REVERSAL"] = "83404949";
    CoreCardTransactionCode["MANUAL_CREDIT_BALANCE_REFUND"] = "834350";
    CoreCardTransactionCode["ACH_CREDIT_BALANCE_REFUND"] = "8344050";
    CoreCardTransactionCode["ACH_CREDIT_BALANCE_REFUND_REVERSAL"] = "8344049";
    CoreCardTransactionCode["AUTOMATIC_INITIAL_CHARGE_OFF"] = "834550";
    CoreCardTransactionCode["INITIAL_CHARGE_OFF_REVERSAL"] = "834006";
    CoreCardTransactionCode["SMALL_BALANCE_WRITE_OFF_DEBIT"] = "834648";
    CoreCardTransactionCode["SMALL_BALANCE_WRITE_OFF_CREDIT"] = "834649";
    CoreCardTransactionCode["FORGIVEN_BALANCE_WRITE_OFF_CREDIT"] = "8301049";
    CoreCardTransactionCode["PRE_AUTHORIZATION_REQUEST"] = "83493";
    CoreCardTransactionCode["AUTHORIZATION_REVERSAL"] = "834397";
    CoreCardTransactionCode["MINIMUM_CHARGE"] = "834995";
    CoreCardTransactionCode["WRITTEN_OFF_BY_BANK_NON_FRAUD"] = "834998";
    CoreCardTransactionCode["WRITTEN_OFF_BY_BANK_FRAUD"] = "834997";
    CoreCardTransactionCode["DISPUTE_PURCHASE_REPOSTED"] = "8341340";
    CoreCardTransactionCode["DISPUTE_PURCHASE_CREDIT"] = "8341443";
    CoreCardTransactionCode["CASH_OUT"] = "834440";
    CoreCardTransactionCode["CASH_OUT_FEE"] = "834406";
    CoreCardTransactionCode["CASH_OUT_REVERSAL"] = "834443";
    CoreCardTransactionCode["CASH_OUT_FEE_REVERSAL"] = "834407";
    CoreCardTransactionCode["CASH_OUT_NO_FEE"] = "830040";
    CoreCardTransactionCode["CASH_OUT_NO_FEE_REVERSAL"] = "830043";
    CoreCardTransactionCode["ORIGINATION_FEE"] = "83706";
    CoreCardTransactionCode["ORIGINATION_FEE_CREDIT_ADJUSTMENT"] = "83907";
    CoreCardTransactionCode["AMORTIZATION_LOAN_FEE"] = "830010";
    CoreCardTransactionCode["AMORTIZATION_LOAN_FEE_REVERSAL"] = "830011";
    CoreCardTransactionCode["BALLOON_INTERNAL_PAYOFF"] = "830121";
    CoreCardTransactionCode["BALLOON_INTERNAL_PAYOFF_REVERSAL"] = "830122";
    CoreCardTransactionCode["BALLOON_REPAYMENT_PLAN"] = "830140";
    CoreCardTransactionCode["BALLOON_REPAYMENT_PLAN_REVERSAL"] = "830143";
    CoreCardTransactionCode["DIRECTED_INTERNAL_PAYOFF"] = "830123";
    CoreCardTransactionCode["DIRECTED_INTERNAL_PAYOFF_REVERSAL"] = "830124";
    CoreCardTransactionCode["INTERNAL_PLAN_TRANSFER_NO_FEE"] = "830240";
    CoreCardTransactionCode["INTERNAL_PLAN_TRANSFER_NO_FEE_REVERSAL"] = "830243";
    /** @deprecated DO NOT USE THIS CODE - when posting this CoreCard will automatically add a 2% fee as a separate transaction */
    CoreCardTransactionCode["DEPRECATED_INTERNAL_PLAN_TRANSFER"] = "830340";
    CoreCardTransactionCode["INTERNAL_PLAN_TRANSFER_REVERSAL"] = "830343";
    CoreCardTransactionCode["CRYPTO_LIQUIDATION_PAYMENT"] = "834750";
    CoreCardTransactionCode["CRYPTO_LIQUIDATION_PAYMENT_REVERSAL"] = "834751";
    CoreCardTransactionCode["STATE_RECORDING_CHARGE"] = "838440";
    CoreCardTransactionCode["STATE_RECORDING_CHARGE_REVERSAL"] = "838443";
    CoreCardTransactionCode["SIGNING_CHARGE"] = "83838400";
    CoreCardTransactionCode["SIGNING_CHARGE_REVERSAL"] = "83838443";
    CoreCardTransactionCode["DISPUTE_ADD"] = "834301";
    CoreCardTransactionCode["DISPUTE_RELEASE_NO_INTEREST_CHG_FEE"] = "834304";
    CoreCardTransactionCode["DISPUTE_RELEASE_WITH_INTEREST_CHG_FEE"] = "834009";
    CoreCardTransactionCode["DISPUTE_RELEASE_CLIENT_FAVOR"] = "834311";
    CoreCardTransactionCode["REVERSAL_OF_DISPUTE_RESOLVED_IN_FAVOR_MERCHANT"] = "834118";
    CoreCardTransactionCode["DEBT_PROTECTION_PLAN_FEE"] = "8344018";
    CoreCardTransactionCode["DEBT_PROTECTION_PLAN_FEE_REVERSAL"] = "8344019";
    // The below 5 tran codes are created through https://coretrack.corecard.com/edit_bug.aspx?id=98867
    CoreCardTransactionCode["CASH_OUT_INCL_FEE"] = "83090040";
    CoreCardTransactionCode["CASH_OUT_INCL_FEE_REVERSAL"] = "830110041";
    CoreCardTransactionCode["BALANCE_TRANSFER_INCL_FEE"] = "830120040";
    CoreCardTransactionCode["BALANCE_TRANSFER_INCL_FEE_REVERSAL"] = "830130041";
    CoreCardTransactionCode["CO_FEE_REVERSAL"] = "830110049";
    CoreCardTransactionCode["BT_FEE_REVERSAL_OLD"] = "834996";
    CoreCardTransactionCode["BT_FEE_REVERSAL"] = "830000149";
    // The below 2 tran codes created through https://coretrack.corecard.com/edit_bug.aspx?id=128776
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_INCL_FEE"] = "834140040";
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_INCL_FEE_REVERSAL"] = "834140043";
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_FEE_REVERSAL"] = "834140049";
    // The below 9 tran codes created through https://coretrack.corecard.com/edit_bug.aspx?id=158316
    // They have no warehousing
    CoreCardTransactionCode["CASH_OUT_INCL_FEE_NO_WAREHOUSE"] = "834150040";
    CoreCardTransactionCode["CASH_OUT_INCL_FEE_REVERSAL_NO_WAREHOUSE"] = "834150043";
    CoreCardTransactionCode["BALANCE_TRANSFER_INCL_FEE_NO_WAREHOUSE"] = "834160040";
    CoreCardTransactionCode["BALANCE_TRANSFER_INCL_FEE_REVERSAL_NO_WAREHOUSE"] = "834160043";
    CoreCardTransactionCode["CO_FEE_REVERSAL_NO_WAREHOUSE"] = "834150049";
    CoreCardTransactionCode["BT_FEE_REVERSAL_NO_WAREHOUSE"] = "834160049";
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_INCL_FEE_NO_WAREHOUSE"] = "834170040";
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_INCL_FEE_REVERSAL_NO_WAREHOUSE"] = "834170043";
    CoreCardTransactionCode["INSTANT_BALANCE_TRANSFER_FEE_REVERSAL_NO_WAREHOUSE"] = "834170049";
    // below 2 tran codes created through https://coretrack.corecard.com/edit_bug.aspx?id=189200
    CoreCardTransactionCode["TRANSFER_TO_MERCHANT"] = "834190040";
    CoreCardTransactionCode["TRANSFER_TO_MERCHANT_REVERSAL"] = "834190043";
    CoreCardTransactionCode["AUTO_LOAN_REFINANCE"] = "83084040";
    CoreCardTransactionCode["AUTO_LOAN_REFINANCE_REVERSAL"] = "83084043";
    CoreCardTransactionCode["HELOC_REFINANCE_PRINCIPAL_DEBIT_DEPRECATED"] = "8340048";
    CoreCardTransactionCode["HELOC_REFINANCE_PRINCIPAL_CREDIT_DEPRECATED"] = "8340049";
    CoreCardTransactionCode["HELOC_REFINANCE"] = "834180040";
    CoreCardTransactionCode["HELOC_REFINANCE_REVERSAL"] = "834180043";
    CoreCardTransactionCode["HELOC_REFINANCE_CASHIERS_CHECK"] = "83420040";
    CoreCardTransactionCode["HELOC_REFINANCE_CASHIERS_CHECK_REVERSAL"] = "83420043";
    CoreCardTransactionCode["HELOC_REFINANCE_INCL_FEE"] = "83410140";
    CoreCardTransactionCode["HELOC_REFINANCE_INCL_FEE_REVERSAL"] = "83410143";
    CoreCardTransactionCode["HOME_PURCHASE_LOAN"] = "830201040";
    CoreCardTransactionCode["HOME_PURCHASE_LOAN_REVERSAL"] = "830201043";
    CoreCardTransactionCode["HELOC_REFI_FEE"] = "8304506";
    CoreCardTransactionCode["HELOC_REFI_FEE_REVERSAL"] = "8304507";
    // Impounds
    CoreCardTransactionCode["IMPOUND_CHARGE"] = "83440140";
    CoreCardTransactionCode["IMPOUND_CHARGE_REVERSAL"] = "83440143";
    // Payments
    CoreCardTransactionCode["ACH_PAYMENT"] = "834780";
    CoreCardTransactionCode["ACH_PAYMENT_REVERSAL"] = "834222";
    CoreCardTransactionCode["LONG_HOLD_ACH_PAYMENT"] = "8341121";
    CoreCardTransactionCode["LONG_HOLD_ACH_PAYMENT_REVERSAL"] = "8341122";
    CoreCardTransactionCode["ELOCKBOX_PAYMENT"] = "830321";
    CoreCardTransactionCode["ELOCKBOX_PAYMENT_REVERSAL"] = "830322";
    CoreCardTransactionCode["DEBIT_CARD_PAYMENT"] = "83921";
    CoreCardTransactionCode["DEBIT_CARD_PAYMENT_REVERSAL"] = "83922";
    CoreCardTransactionCode["PAYOFF"] = "830221";
    CoreCardTransactionCode["PAYOFF_REVERSAL"] = "830222";
    CoreCardTransactionCode["EXTERNAL_BILL_PAYMENT"] = "834022";
    CoreCardTransactionCode["EXTERNAL_BILL_PAYMENT_REVERSAL"] = "834023";
    CoreCardTransactionCode["WIRE_PAYOFF"] = "83400121";
    CoreCardTransactionCode["WIRE_PAYOFF_REVERSAL"] = "83400122";
    CoreCardTransactionCode["WIRE_PAYMENT"] = "834000121";
    CoreCardTransactionCode["WIRE_PAYMENT_REVERSAL"] = "834000122";
    CoreCardTransactionCode["CHECK_PAYMENT"] = "8310021";
    CoreCardTransactionCode["CHECK_PAYMENT_REVERSAL"] = "8310022";
    CoreCardTransactionCode["THIRD_PARTY_COLLECTIONS_PAYMENT"] = "834600021";
    CoreCardTransactionCode["THIRD_PARTY_COLLECTIONS_PAYMENT_REVERSAL"] = "834600022";
    CoreCardTransactionCode["POST_CHARGE_OFF_PAYMENT"] = "8344521";
    CoreCardTransactionCode["POST_CHARGE_OFF_PAYMENT_REVERSAL"] = "8344522";
    CoreCardTransactionCode["POST_CHARGE_OFF_CHECK_PAYMENT"] = "83420021";
    CoreCardTransactionCode["POST_CHARGE_OFF_CHECK_PAYMENT_REVERSAL"] = "83420022";
    CoreCardTransactionCode["POST_CHARGE_OFF_WIRE_PAYMENT"] = "83410021";
    CoreCardTransactionCode["POST_CHARGE_OFF_WIRE_PAYMENT_REVERSAL"] = "83410022";
    CoreCardTransactionCode["POST_CHARGE_OFF_COLLECTIONS_RECOVERY_PAYMENT"] = "834700021";
    CoreCardTransactionCode["POST_CHARGE_OFF_COLLECTIONS_RECOVERY_PAYMENT_REVERSAL"] = "834700022";
    CoreCardTransactionCode["PAYMENT_ADJUSTMENT"] = "83945";
    CoreCardTransactionCode["OVERPAYMENT_REFUND"] = "830148";
    // Directed Payments
    CoreCardTransactionCode["DIRECTED_PAYMENT"] = "8301230";
    CoreCardTransactionCode["DIRECTED_PAYMENT_REVERSAL"] = "8301231";
    CoreCardTransactionCode["DIRECTED_ACH_PAYMENT"] = "83478023";
    CoreCardTransactionCode["DIRECTED_ACH_PAYMENT_REVERSAL"] = "83500122";
    CoreCardTransactionCode["DIRECTED_ELOCKBOX_PAYMENT"] = "830423";
    CoreCardTransactionCode["DIRECTED_ELOCKBOX_PAYMENT_REVERSAL"] = "8301322";
    CoreCardTransactionCode["DIRECTED_DEBIT_CARD_PAYMENT"] = "83923";
    CoreCardTransactionCode["DIRECTED_DEBIT_CARD_PAYMENT_REVERSAL"] = "839122";
    CoreCardTransactionCode["DIRECTED_PAYOFF"] = "830023";
    CoreCardTransactionCode["DIRECTED_PAYOFF_REVERSAL"] = "8301222";
    CoreCardTransactionCode["DIRECTED_EXTERNAL_BILL_PAYMENT"] = "8340023";
    CoreCardTransactionCode["DIRECTED_EXTERNAL_BILL_PAYMENT_REVERSAL"] = "83401232";
    // DIRECTED WIRE PAYOFF? requested in https://coretrack.corecard.com/edit_bug.aspx?id=175477
    // DIRECTED WIRE PAYOFF REVERSAL? requested in https://coretrack.corecard.com/edit_bug.aspx?id=175477
    // DIRECTED WIRE PAYMENT? requested in https://coretrack.corecard.com/edit_bug.aspx?id=175477
    // DIRECTED WIRE PAYMENT REVERSAL? requested in https://coretrack.corecard.com/edit_bug.aspx?id=175477
    CoreCardTransactionCode["DIRECTED_CHECK_PAYMENT"] = "8310023";
    CoreCardTransactionCode["DIRECTED_CHECK_PAYMENT_REVERSAL"] = "83100122";
    CoreCardTransactionCode["DIRECTED_POST_CHARGE_OFF_PAYMENT"] = "8344523";
    CoreCardTransactionCode["DIRECTED_POST_CHARGE_OFF_PAYMENT_REVERSAL"] = "83441522";
    CoreCardTransactionCode["DIRECTED_CASHBACK_REDEMPTION"] = "834123";
    CoreCardTransactionCode["DIRECTED_CRYPTO_LIQUIDATION_PAYMENT"] = "83475023";
    CoreCardTransactionCode["DIRECTED_CRYPTO_LIQUIDATION_PAYMENT_REVERSAL"] = "83475122";
    CoreCardTransactionCode["DIRECTED_PAYMENT_ADJUSTMENT"] = "8394523";
    // Logic Module     Logic Module Description    Transaction Code    Transaction Code Description
    // 23               Directed Payment            83400023            Directed Principal Rebalance Credit
    // 22               Payment Reversal            83400022            Directed Principal Rebalance Credit Reversal
    // 48               Principal Debit             83400048            Directed Principal Rebalance Debit
    // 49               Principal Credit            83400149            Directed Principal Rebalance Debit Reversal
    CoreCardTransactionCode["DIRECTED_PRINCIPAL_REBALANCE_CREDIT"] = "83400023";
    CoreCardTransactionCode["DIRECTED_PRINCIPAL_REBALANCE_CREDIT_REVERSAL"] = "83400022";
    CoreCardTransactionCode["DIRECTED_PRINCIPAL_REBALANCE_DEBIT"] = "83400048";
    CoreCardTransactionCode["DIRECTED_PRINCIPAL_REBALANCE_DEBIT_REVERSAL"] = "83400149";
    // CoreCard credit movement tran codes -- bookkeeping tran codes that do not reflect transactions
    CoreCardTransactionCode["BOOKKEEPING_CREDIT_MOVEMENT"] = "3887";
    CoreCardTransactionCode["BOOKKEEPING_DEBIT_MOVEMENT"] = "3888";
    CoreCardTransactionCode["SOURCE_PRODUCT_PRINCIPAL"] = "834027";
    CoreCardTransactionCode["DESTINATION_PRODUCT_PRINCIPAL"] = "834302";
    CoreCardTransactionCode["SOURCE_PRODUCT_INTEREST_BLLLED_NOT_PAID"] = "834303";
    CoreCardTransactionCode["DESTINATION_PRODUCT_INTEREST_BLLLED_NOT_PAID"] = "834012";
    CoreCardTransactionCode["SOURCE_PRODUCT_PREMIUM_BILLED_NOT_PAID"] = "834309";
    CoreCardTransactionCode["DESTINATION_PRODUCT_PREMIUM_BILLED_NOT_PAID"] = "834310";
    CoreCardTransactionCode["SOURCE_PRODUCT_MEMBERSHIP_BILLED_NOT_PAID"] = "834015";
    CoreCardTransactionCode["DESTINATION_PRODUCT_MEMBERSHIP_BILLED_NOT_PAID"] = "834312";
    // Flood Force Placement, HOI Force Placement, and Property Tax Placement started using distinct tran codes in July 2025, before that we used Statement Principal Debit
    CoreCardTransactionCode["FLOOD_INSURANCE_POLICY_FORCED_PLACEMENT"] = "830248";
    CoreCardTransactionCode["FLOOD_INSURANCE_POLICY_FORCED_PLACEMENT_REVERSAL"] = "830249";
    CoreCardTransactionCode["HOME_OWNER_INSURANCE_FORCE_PLACEMENT"] = "834102048";
    CoreCardTransactionCode["HOME_OWNER_INSURANCE_FORCE_PLACEMENT_REVERSAL"] = "834102049";
    CoreCardTransactionCode["PROPERTY_TAX_PLACEMENT"] = "83420048";
    CoreCardTransactionCode["PROPERTY_TAX_PLACEMENT_REVERSAL"] = "83420049";
    CoreCardTransactionCode["FORCE_POST_ON_NON_FRAUD_ACCOUNT"] = "35101";
    // trancodes for Aven Travel
    CoreCardTransactionCode["TRAVEL_BOOKING_INCL_FEE"] = "83420140";
    CoreCardTransactionCode["TRAVEL_BOOKING_INCL_FEE_REVERSAL"] = "83420143";
    CoreCardTransactionCode["TRAVEL_BOOKING_REFUND"] = "83420141";
    CoreCardTransactionCode["TRAVEL_BOOKING_REFUND_REVERSAL"] = "83420142";
    CoreCardTransactionCode["CRYPTO_LIQUIDATION_FEE"] = "834606";
    // Monthly interest rebate (0% APR Forever statement credit)
    CoreCardTransactionCode["MONTHLY_REVOLVING_INTEREST_REBATE"] = "8301003";
})(CoreCardTransactionCode || (exports.CoreCardTransactionCode = CoreCardTransactionCode = {}));
// TODO: Rename or consolidate with CoreCardPlanType in avenCreditCardManager.types.ts and planAttributesPlanType in aven_types
var CoreCardPlanType;
(function (CoreCardPlanType) {
    CoreCardPlanType["Retail"] = "Retail";
    CoreCardPlanType["Purchase"] = "Purchase";
    CoreCardPlanType["BalanceTransfer"] = "Balance Transfer";
    CoreCardPlanType["PromotionalPurchases"] = "Promotional Purchases";
    CoreCardPlanType["Cash"] = "Cash";
})(CoreCardPlanType || (exports.CoreCardPlanType = CoreCardPlanType = {}));
